import { mapGetters, mapActions } from 'vuex'

export const viewerPDFActions = {
  ...mapActions('viewerPDFStore', [
    'setUrlPDF',
    'setPDFOk',
    'setInfoPDF',
    'setLabelsPDF',
    'cleanObjectPDF',
    'downloadDocumentPdf',
    'downloadDocumentPdfByToken'
  ])
}
  
export const viewerPDFData = {
  ...mapGetters('viewerPDFStore', [
    'urlPDF',
    'filePDF',
    'okPDF',
    'infoPDF',
    'labelsPDF',
    'numPages',
    'pdfIsBusy'
  ])
}